import React, { createContext, useState } from 'react';

// Criação do contexto
const ImagesToExportContext = createContext();

export { ImagesToExportContext };

// Provedor do contexto
export default function ImagesToExportContextProvider({ children }) {
    const [btnText, setBtnText] = useState('Export Images');
    const [imagesToExport, setImagesToExport] = useState([]);
    return (
        <ImagesToExportContext.Provider value={{ 
            btnText, 
            setBtnText,
            imagesToExport, 
            setImagesToExport
        }}>
            {children}
        </ImagesToExportContext.Provider>
    );
}